<script setup lang="ts">
withDefaults(defineProps<{
  variant?: 'elevated' | 'flat' | 'outlined' | 'tonal'
  rounded?: string
  hover?: boolean
  loading?: boolean
  to?: string | object
  href?: string
  color?: string
  flat?: boolean
}>(), {
  variant: 'elevated',
})

const NuxtLink = defineNuxtLink({})
</script>

<template>
  <component
    :is="to ? NuxtLink : href ? 'a' : 'div'"
    v-bind="to ? { to } : href ? { href, target: '_blank', rel: 'noopener' } : {}"
    class="m-card"
    :class="[
      `m-card--${flat ? 'flat' : variant}`,
      {
        'm-card--hover': hover,
        'm-card--loading': loading,
        'm-card--link': to || href,
      }
    ]"
  >
    <div v-if="loading" class="m-card__loader">
      <div class="m-card__progress" />
    </div>
    <slot />
  </component>
</template>

<style scoped>
.m-card {
  background: var(--m-surface);
  border-radius: var(--m-radius);
  position: relative;
  overflow: hidden;
  text-decoration: none;
  color: var(--m-on-surface);
}

.m-card--elevated { box-shadow: var(--m-shadow); }
.m-card--flat { box-shadow: none; }
.m-card--outlined { box-shadow: none; border: 1px solid var(--m-border); }
.m-card--tonal { background: var(--m-surface-variant); }

.m-card--hover { transition: box-shadow var(--m-transition), transform var(--m-transition); cursor: pointer; }
.m-card--hover:hover { box-shadow: var(--m-shadow-lg); transform: translateY(-2px); }

.m-card--link { cursor: pointer; }
.m-card--link:hover { box-shadow: var(--m-shadow-md); }

.m-card__loader { position: absolute; top: 0; left: 0; right: 0; height: 3px; overflow: hidden; }
.m-card__progress {
  height: 100%;
  background: var(--m-primary);
  animation: m-card-loading 1.5s ease-in-out infinite;
}

@keyframes m-card-loading {
  0% { width: 0; margin-left: 0; }
  50% { width: 60%; margin-left: 20%; }
  100% { width: 0; margin-left: 100%; }
}
</style>
